import { connect } from 'react-redux'
import { resetPassword, clearReset } from 'redux/modules/auth'

import ResetPasswordComponent from '../components/ResetPasswordComponent'

const mapActionCreators = {
  resetPassword,
  clearReset
}

const mapStateToProps = state => ({
  auth: state.auth
})

export default connect(mapStateToProps, mapActionCreators)(
  ResetPasswordComponent
)



// WEBPACK FOOTER //
// ./src/routes/ResetPassword/containers/ResetPasswordContainer.js